/* global UI_VERSION */

/**
 * Get a font's URL from its path within the fonts folder.
 * @param {String} path - A path to the font.
 */
const getFontUrl = (path) => `${window.location.protocol}//${window.location.host}/static/${UI_VERSION.replace(/"/gi, '')}/fonts/${path}`;

export default [{
  fallbacks: {
    src: [
      'local("Barlow Condensed Light ")',
      'local("Barlow Condensed-Light")',
      `url("${getFontUrl('barlow-condensed-latin-300')}.woff2") format("woff2")`,
      `url("${getFontUrl('barlow-condensed-latin-300')}.woff") format("woff")`
    ]
  },
  fontDisplay: 'swap',
  fontFamily: '"Barlow Condensed"',
  fontStyle: 'normal',
  fontWeight: 300
}, {
  fallbacks: {
    src: [
      'local("Roboto Condensed ")',
      `url("${getFontUrl('robotocondensed-light-webfont')}.woff2") format("woff2")`,
      `url("${getFontUrl('robotocondensed-light-webfont')}.woff") format("woff")`
    ]
  },
  fontDisplay: 'swap',
  fontFamily: '"Roboto Condensed"',
  fontStyle: 'normal',
  fontWeight: 300
}, {
  fallbacks: {
    src: [
      'local("Roboto Condensed ")',
      `url("${getFontUrl('robotocondensed-regular-webfont')}.woff2") format("woff2")`,
      `url("${getFontUrl('robotocondensed-regular-webfont')}.woff") format("woff")`
    ]
  },
  fontDisplay: 'swap',
  fontFamily: '"Roboto Condensed"',
  fontStyle: 'normal',
  fontWeight: 400
}, {
  fallbacks: {
    src: [
      'local("Roboto Condensed ")',
      `url("${getFontUrl('robotocondensed-bold-webfont')}.woff2") format("woff2")`,
      `url("${getFontUrl('robotocondensed-bold-webfont')}.woff") format("woff")`
    ]
  },
  fontDisplay: 'swap',
  fontFamily: '"Roboto Condensed"',
  fontStyle: 'normal',
  fontWeight: 700
}, {
  fallbacks: {
    src: [
      'local("Roboto ")',
      `url("${getFontUrl('roboto-light')}.woff2") format("woff2")`,
      `url("${getFontUrl('roboto-light')}.woff") format("woff")`
    ]
  },
  fontDisplay: 'swap',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 300
}, {
  fallbacks: {
    src: [
      'local("Roboto ")',
      `url("${getFontUrl('roboto-regular')}.woff2") format("woff2")`,
      `url("${getFontUrl('roboto-regular')}.woff") format("woff")`
    ]
  },
  fontDisplay: 'swap',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400
}, {
  fallbacks: {
    src: [
      'local("Roboto ")',
      `url("${getFontUrl('roboto-bold')}.woff2") format("woff2")`,
      `url("${getFontUrl('roboto-bold')}.woff") format("woff")`
    ]
  },
  fontDisplay: 'swap',
  fontFamily: '"Roboto"',
  fontStyle: 'normal',
  fontWeight: 700
}];
